import { Search } from "@mui/icons-material";
import { Button, InputAdornment, List, ListItem, TextField } from "@mui/material/";
import React, { useEffect, useState } from "react";

import { useDebouncedEffect } from "../../../../hooks/useDebounceEffect";
import { useHistoryNavigate } from "../../../../hooks/useHistoryNavigate";
import useService from "../../../../hooks/useService";

export default function ClientSearchMinimized() {
  const caseRepository = useService("repositories/case-repository");
  const [responseData, setResponseData] = useState([]);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const { historyNavigate } = useHistoryNavigate();

  // reset filter
  const resetClients = (e) => {
    setSearch("");
  };

  // Handling client onClick
  function handleClient(client) {
    historyNavigate("client-detail", client?.pk);
    setSearch("");
  }

  const sendRequest = async () => {
    const searchQuery = debouncedSearch ? debouncedSearch : "";
    try {
      const caseList = await caseRepository.query({
        "data-set": "search",
        search: searchQuery,
      });
      if (caseList) {
        setResponseData(caseList);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    sendRequest();
  }, [debouncedSearch]);

  useDebouncedEffect(() => setDebouncedSearch(search), [search], 700);

  return (
    <div className="relative w-full">
      <div className="flex items-center py-5 xl:h-1/6">
        <TextField
          className="mx-4 w-full rounded-lg placeholder:text-center"
          placeholder="Search"
          size="small"
          value={search}
          onChange={(event) => setSearch(event.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
        />
        <Button
          variant="outlined"
          color="error"
          onClick={resetClients}
          className="w-1/8 mr-4 rounded-md hover:bg-red-500 hover:text-white"
        >
          Reset
        </Button>
      </div>
      {!responseData ? (
        ""
      ) : !search ? (
        ""
      ) : (
        <List className="absolute z-10 max-h-[50vh] w-full overflow-y-auto rounded-b-md bg-white p-0 shadow-lg">
          {responseData.map((client, index) => (
            <ListItem
              key={index}
              onClick={(e) => handleClient(client)}
              className="border-gray flex w-full rounded-lg border-b bg-white px-2 hover:bg-purple-600"
            >
              {client?.client?.name}
            </ListItem>
          ))}
        </List>
      )}
    </div>
  );
}
